import { render } from "./PagesList.vue?vue&type=template&id=7e517ae4&scoped=true"
import script from "./PagesList.vue?vue&type=script&lang=js"
export * from "./PagesList.vue?vue&type=script&lang=js"

import "./PagesList.vue?vue&type=style&index=0&id=7e517ae4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e517ae4"]])

export default __exports__